export default __webpack_public_path__ + "static/media/Izmir-Light.10dd522c.woff";